// extracted by mini-css-extract-plugin
export var divider = "_pt-0";
export var systemMessage = "_pt-1";